class ExportIterator {
  constructor() {
    if (new.target === ExportIterator) {
      throw new TypeError('Cannot construct instances of ExportIterator directly');
    }
    if (this.next === undefined) {
      throw new TypeError('Subclasses of ExportIterator must implement `next`');
    }
    if (this.hasNext === undefined) {
      throw new TypeError('Subclasses of ExportIterator must implement `hasNext`');
    }
  }
}
export default ExportIterator;